import Vue from 'vue';
import Router from 'vue-router';

import routes from './routes';
import middlewarePipeline from './middlewarePipeline';

import store from '../store';

Vue.use(Router);

function addTitle(to) {
  const titleInRoute = to.matched.find(item => item.meta.title);
  const { getPageTitle } = store.getters;

  if (titleInRoute !== undefined) {
    window.document.title = getPageTitle
      ? `${getPageTitle} | ${titleInRoute.meta.title}` : titleInRoute.meta.title;
  }
}

const router = new Router({
  routes,
  mode: 'history',
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
});

router.beforeEach((to, from, next) => {
  addTitle(to);

  if (!to.meta.middleware) {
    return next();
  }

  const middleware = to.meta.middleware;
  const context = { to, from, next, store };

  return middleware[0]({
    ...context,
    next: middlewarePipeline(context, middleware, 1),
  });
});

export default router;
